import { render, staticRenderFns } from "./TheAccessWalletLayout.vue?vue&type=template&id=3bc9ea6a&scoped=true"
import script from "./TheAccessWalletLayout.vue?vue&type=script&lang=js"
export * from "./TheAccessWalletLayout.vue?vue&type=script&lang=js"
import style0 from "./TheAccessWalletLayout.vue?vue&type=style&index=0&id=3bc9ea6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc9ea6a",
  null
  
)

export default component.exports